<div class="basin-pb-4 basin-width-100">

  <div class="basin-pb-2 basin-width-100">
    <div class="basin-display-flex basin-align-items-center basin-pb-2">
      By sharing access with this DFP Specialist, you are sharing the study area and its associated simulation results.
    </div>
  </div>
  <form [formGroup]="form" class="form-container basin-display-flex basin-gap-2">
    <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
  </form>
</div>

<div class="basin-display-flex basin-justify-content-end basin-width-100">
  <button pButton type="button" (click)="onCancel()" class="p-button-text basin-mr-6">
    Cancel
  </button>

  <button pButton type="submit" (click)="onSave()" class="p-button-text">
    Save
  </button>
</div>